import {Component, Input, OnInit} from '@angular/core';
import {MyDialogDataModel} from '../../../models/my-dialog-data.model';
import {EditModalService} from '../../../services/edit-modal.service';
import {ControlContainer, NgForm} from '@angular/forms';

@Component({
    selector: 'app-empty-containers-form-invalidator',
    templateUrl: './empty-containers-form-invalidator.component.html',
    styleUrls: ['./empty-containers-form-invalidator.component.scss'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class EmptyContainersFormInvalidatorComponent implements OnInit {


    public model: MyDialogDataModel;
    @Input() public forceFormValidationVisibility: boolean;

    constructor(
        public  editModalService: EditModalService,
    ) {
    }


    ngOnInit(): void {
        this.model = this.editModalService.getDialogModel();
    }

}
